import { motion } from "framer-motion";
import { ArrowUpRight, Bot, Braces, Database, Workflow } from "lucide-react";

const technologies = ["React", "Node.js", "PostgreSQL", "n8n"];

export function SampleProjectCard() {
  return (
    <motion.article
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.55 }}
      className="group grid overflow-hidden rounded-[2rem] border border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:border-ring lg:grid-cols-[1.25fr_0.75fr]"
    >
      <div className="relative min-h-72 overflow-hidden border-b border-border p-6 sm:min-h-96 sm:p-10 lg:border-b-0 lg:border-r">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,color-mix(in_oklab,var(--foreground)_10%,transparent),transparent_42%)]" />
        <div className="absolute inset-0 opacity-40 [background-image:linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] [background-size:42px_42px] [mask-image:linear-gradient(to_bottom,black,transparent)]" />

        <div className="relative flex h-full items-center justify-center">
          <div className="relative flex items-center gap-3 sm:gap-6">
            <div className="rounded-2xl border border-border bg-background/90 p-4 shadow-xl sm:p-6">
              <Bot className="h-8 w-8 text-foreground sm:h-11 sm:w-11" strokeWidth={1.4} />
            </div>
            <div className="h-px w-8 bg-border sm:w-16" />
            <div className="rounded-2xl border border-border bg-background/90 p-4 shadow-xl sm:p-6">
              <Workflow className="h-8 w-8 text-foreground sm:h-11 sm:w-11" strokeWidth={1.4} />
            </div>
            <div className="h-px w-8 bg-border sm:w-16" />
            <div className="rounded-2xl border border-border bg-background/90 p-4 shadow-xl sm:p-6">
              <Database className="h-8 w-8 text-foreground sm:h-11 sm:w-11" strokeWidth={1.4} />
            </div>
          </div>
        </div>

        <span className="absolute left-6 top-6 rounded-full border border-border bg-background/80 px-3 py-1.5 font-body text-[10px] uppercase tracking-[0.18em] text-muted-foreground backdrop-blur sm:left-10 sm:top-10">
          Sample project
        </span>
      </div>

      <div className="flex flex-col justify-between p-7 sm:p-10">
        <div>
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="font-body text-xs uppercase tracking-[0.18em] text-muted-foreground">
                AI Automation
              </p>
              <h3 className="font-heading text-2xl text-foreground mt-3">
                FlowPilot AI
              </h3>
            </div>
            <div className="rounded-full border border-border p-2.5 transition-transform duration-300 group-hover:rotate-45">
              <ArrowUpRight className="h-4 w-4 text-foreground" />
            </div>
          </div>

          <p className="font-body text-sm leading-relaxed text-muted-foreground mt-5">
            A sample intelligent workflow platform that connects business tools,
            automates repetitive operations, and gives teams a clear view of every process.
          </p>

          <div className="mt-7 grid grid-cols-2 gap-3">
            <div className="rounded-2xl border border-border bg-background/50 p-4">
              <Workflow className="h-5 w-5 text-foreground" />
              <p className="font-body text-xs text-muted-foreground mt-3">Workflow automation</p>
            </div>
            <div className="rounded-2xl border border-border bg-background/50 p-4">
              <Braces className="h-5 w-5 text-foreground" />
              <p className="font-body text-xs text-muted-foreground mt-3">API integrations</p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mt-8 pt-6 border-t border-border">
          {technologies.map((technology) => (
            <span
              key={technology}
              className="rounded-full border border-border px-3 py-1.5 font-body text-xs text-muted-foreground"
            >
              {technology}
            </span>
          ))}
        </div>
      </div>
    </motion.article>
  );
}
